export default {
  body: {
    cmpt: {
      type: 'CProductEdit'
    }
  }
}
